module.exports = __webpack_public_path__ + "img/shop_question_banner@2x.d9e2ac96.png";